// Module
var code = "<div class=\"fill\"> <wt-loading-panel is-loading=\"vm.isLoading\" message=\"vm.loadingMessage\"></wt-loading-panel> <div style=\"display:flex;flex-direction:column;align-items:center;justify-content:center\"> <span>{{'Connecting to WiDE using Microsoft Entra ID'|translate}}</span> </div> </div>";
// Exports
module.exports = code;